import React from 'react';
import { C, type SavedProject } from '@doer/frontend-components/creativity-editor';
import { ProjectsList } from './project-list';

type SidebarProps = {
  project: {
    currentId: string | null;
    projects: SavedProject[];
    onSelect: (projectId: string) => void;
  };
};

export const Sidebar: React.FC<SidebarProps> = ({ project }) => {
  return (
    <div
      style={{
        width: '200px',
        background: C.bg,
        border: `1px solid ${C.border}`,
        borderRadius: '16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '12px 0',
        gap: '4px',
        position: 'absolute',
        left: '16px',
        top: '20%',
        zIndex: 10,
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
      }}
    >
      <ProjectsList
        currentProjectId={project.currentId}
        projects={project.projects}
        onSelectProject={project.onSelect}
      />
    </div>
  );
};
